import { Message } from 'element-ui';
import { http, httpWithToken } from "./http";

export function request(config){
    return http(config)
      .then((res) => {
        const data = res && res.data ? res.data : res;
        if (data && data.code != 200) {
            Message.error(data.msg || "请求失败");
        }
        return data;
      })
      .catch((err) => {
        Message.error((err && err.message) ? err.message : "网络异常");
        return { code: -1, msg: "网络异常", data: null };
      });
}

export function requestWithToken(config){
    return httpWithToken(config)
      .then((res) => {
        const data = res && res.data ? res.data : res;
        if (data && data.code != 200) {
            Message.error(data.msg || "请求失败");
        }
        return data;
      })
      .catch((err) => {
        // 401/403 跳转已在 httpWithToken 拦截器中处理
        Message.error((err && err.message) ? err.message : "网络异常");
        return { code: -1, msg: "网络异常", data: null };
      });
}